/**
 * SOLID Review
 * S — Strong. One use case: roll the dice — the plan, the server told, the table at the peek.
 * O — Strong. The round trip runs it; a change of rule is the Domain's, of sequence the round trip's.
 * L — Strong. Implements its use-case role and the round trip's three strategies exactly.
 * I — Strong. `execute`, and the three strategies the round trip asks for.
 * D — Strong. The decisions and server ports and the round trip, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { IPropsClientTableInput } from '../../domain/ports/schemas/ClientTable';
import type { ICommandNothing, ICommandRoundMoveAnswered, IPayloadRoundMove } from '../../domain/ports/schemas/TableMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { TServerRoundTrip, TAnsweredVoid } from '../shared/ServerRoundTrip';
import type { IConfigDepTable } from './IConfigDepTable';

/** The roller rolls (FE1's rollDice): the server is told, then the table waits for the peek. */
export class RollDiceUseCase implements IUseCase<ICommandNothing, TPortOutcome>, TServerRoundTrip<IPropsClientTableInput, ICommandNothing, IPayloadRoundMove, TAnsweredVoid> {
  constructor(private readonly deps: IConfigDepTable) {}

  execute(ctx: IContextRequest, command: ICommandNothing): Promise<TPortOutcome> {
    return this.deps.trip.run(ctx, command, this);
  }

  plan(ctx: IContextRequest, input: IPropsClientTableInput, command: ICommandNothing) {
    return this.deps.decisions.planRoll(ctx, input, command);
  }

  send(ctx: IContextRequest, plan: IPayloadRoundMove) {
    return this.deps.rounds.rollDice(ctx, plan);
  }

  answer(ctx: IContextRequest, input: IPropsClientTableInput, plan: IPayloadRoundMove) {
    const rolled: ICommandRoundMoveAnswered = { request: plan };
    return this.deps.decisions.rolled(ctx, input, rolled);
  }
}
